import { Button, Alert, Col, Row, Tag, Table, Card, Modal, Flex } from "antd";
import LineChart from "./LineChart";
import classes from "./SectorsDetailPage.module.scss";
import Marquee from "react-fast-marquee";

import {
  columns,
  dataSource,
  etfTableColumns,
  mutualFundsColumns,
  largestCompaniesColumns,
} from "./constants";
import TreeMapChart from "./TreeMap";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loading";
import { formatToTrillions } from "../../helpers";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../constants";
import { getIndustries } from "../../services/dashboardService";
import { setIndustries } from "../../redux/action";
import PolarChart from "../Dashboard/PolarChart";
import { getIndustryDetails } from "../../services/sectorIndustryService";
import RiskSummaryChart from "../Dashboard/RiskSummaryChart";
import OpportunitySummaryChart from "../Dashboard/OpportunitySummaryChart";
import ImpactForecastingGraph from "../Dashboard/ImpactForecastingGraph";
import ComparativeMetricsTable from "../Dashboard/ComparativeMetricsTable";

const SectorDetailPage = () => {
  const navigate = useNavigate();
  const { id = "" } = useParams();
  const dispatch = useDispatch();

  const sectors = useSelector((state) => state.sectors);
  const sectorsDetails = sectors.find((sector) => sector.sector_key === id);

  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [currentReport, setCurrentReport] = useState(null);

  const getIndustriesDetailsQuery = useQuery({
    queryKey: [queryKeys.industries, id],
    queryFn: () => getIndustries(id),
  });

  const getIndustryDetailsMutation = useMutation({
    mutationFn: getIndustryDetails,
  });

  const [defaultIndustryDetails, setDefaultIndustryDetails] = useState({
    industriesCount: "-",
    companiesCount: "-",
    marketCap: "-",
    marketWeight: "-",
    employeeCount: "-",
    industriesDescription: "", //"sectorsDetails.overview?.description"
  });

  const handleSelectAllIndustry = () => {
    setDefaultIndustryDetails({
      industriesCount: sectors.length,
      companiesCount: sectors.reduce(
        (acc, sector) => acc + sector.overview.industries_count,
        0
      ),
      marketCap: formatToTrillions(
        sectors.reduce((acc, sector) => acc + sector.overview.market_cap, 0)
      ),
      marketWeight: "",
      industriesDescription: sectorsDetails?.overview?.description ?? "",
      employeeCount: "",
      name: "",
    });
  };

  const handleUpdateState = (selectedIndustry) => {
    setDefaultIndustryDetails({
      industriesCount: selectedIndustry.overview.industries_count,
      marketWeight: selectedIndustry.overview.market_weight,
      employeeCount: selectedIndustry.overview.employee_count,
      // companiesCount: selectedIndustry.top_companies.name?.length ?? 0,
      companiesCount: selectedIndustry.overview.companies_count,
      marketCap: formatToTrillions(selectedIndustry.overview.market_cap),
      industriesDescription: selectedIndustry.overview.description,
      name: selectedIndustry.name,
    });
    getIndustryDetailsMutation.mutate({
      sector: id,
      industry_name: selectedIndustry.industry_key,
    });
  };

  useEffect(() => {
    if (sectors && sectors.length) {
      handleSelectAllIndustry();
    }
  }, [sectors]);

  useEffect(() => {
    if (
      getIndustriesDetailsQuery?.data &&
      getIndustriesDetailsQuery?.data?.data
    ) {
      dispatch(setIndustries(getIndustriesDetailsQuery.data.data[0]));
    }
  }, [getIndustriesDetailsQuery?.data]);

  const handleGoToIndustry = () => {
    navigate(
      `/home/sectors-details/${sectorsDetails.sector_key}/industry-details/${selectedIndustry.name}`
    );
  };
  const allIndustries = [
    {
      name: "All Industries",
      overview: {
        market_weight:
          sectorsDetails?.industries?.reduce(
            (acc, industry) => acc + industry.overview.market_weight,
            0
          ) ?? 0,
        // industries_count:
        //   sectorsDetails?.industries?.reduce(
        //     (acc, industry) => acc + industry.overview.industries_count,
        //     0
        //   ) ?? 0,
        companies_count:
          sectorsDetails?.industries?.reduce(
            (acc, industry) => acc + industry.overview.companies_count,
            0
          ) ?? 0,
      },
    },
  ];
  // Tables Work
  const largestCompanies = Object.keys(
    sectorsDetails?.top_companies.name ?? []
  ).map((symbol) => ({
    key: symbol,
    symbol,
    name: sectorsDetails.top_companies.name[symbol],
    marketWeight: sectorsDetails.top_companies["market weight"][symbol],
    rating: sectorsDetails.top_companies.rating[symbol] || "N/A",
  }));
  const mutualFundsData = Object.keys(
    sectorsDetails?.top_mutual_funds ?? []
  ).map((symbol) => ({
    key: symbol,
    symbol,
    name: sectorsDetails.top_mutual_funds[symbol],
  }));
  const etfTableData = Object.keys(sectorsDetails?.top_etfs ?? []).map(
    (symbol) => ({
      key: symbol,
      symbol,
      name: sectorsDetails?.top_etfs[symbol],
    })
  );
  // ---report section --

  const showPopup = (report) => {
    setCurrentReport(report);
    setIsPopupVisible(true);
  };

  const hidePopup = () => {
    setIsPopupVisible(false);
    setCurrentReport(null);
  };

  const handleSelectItem = (item) => {
    console.log("🚀 ~ handleSelectItem ~ item:", item);
  };

  const { data: industryDetail } = getIndustryDetailsMutation?.data?.data
    ?.results?.[0] || { data: {} };

  return getIndustriesDetailsQuery.isLoading ? (
    <Loader />
  ) : (
    <div className={classes.pageContent}>
      <div className={classes.headerSection}>
        <div className={classes.header}>
          <span className={classes.pageTitle}>{sectorsDetails?.name}</span>
          <span className={classes.pageSubTitle}>
            {defaultIndustryDetails.industriesDescription}
          </span>
        </div>
        <div>
          <div className={classes.cardWrapper}>
            {defaultIndustryDetails.marketCap && (
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Market Cap</h5>
                <span className={classes.cardContent}>
                  {defaultIndustryDetails.marketCap}
                </span>
              </div>
            )}
            {defaultIndustryDetails.marketWeight && (
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Market Weight</h5>
                <span className={classes.cardContent}>
                  {(defaultIndustryDetails.marketWeight * 100).toFixed(2)}%
                </span>
              </div>
            )}
            {defaultIndustryDetails.industriesCount && (
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Industries</h5>
                <span className={classes.cardContent}>
                  {defaultIndustryDetails.industriesCount}
                </span>
              </div>
            )}
            {defaultIndustryDetails.companiesCount && (
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Companies</h5>
                <span className={classes.cardContent}>
                  {defaultIndustryDetails.companiesCount}
                </span>
              </div>
            )}
            {defaultIndustryDetails.employeeCount && (
              <div className={classes.card}>
                <h5 className={classes.cardTitle}>Employees</h5>
                <span className={classes.cardContent}>
                  {defaultIndustryDetails.employeeCount}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      {defaultIndustryDetails?.name && (
        <div className={classes.headerContent}>
          <div className={classes.header}>
            <span className={classes.selectSector}>
              Current Status of {defaultIndustryDetails?.name || ""}
            </span>
            <span className={classes.pageSubTitle}>
              {industryDetail?.overview_status?.current_status || ""}
            </span>
            <span className={classes.selectSector}>Key Highlights</span>
            <Flex gap="4px 0" wrap style={{ marginBottom: 10 }}>
              {industryDetail?.overview_status?.key_highlights?.map(
                (highlight) => {
                  return <Tag color="blue">{highlight}</Tag>;
                }
              )}
            </Flex>
          </div>
        </div>
      )}
      <Alert
        banner
        message={
          <Marquee pauseOnHover gradient={false}>
            Sector performance is calculated based on the previous closing price
            of all sector constituents and is weighted by market capitalization.
          </Marquee>
        }
      />
      <div className={classes.chartContainer}>
        <span className={classes.selectSector}>
          Select an Industry for a Visual Breakdown
        </span>
        {selectedIndustry && (
          <Button
            type="primary"
            size="small"
            onClick={handleGoToIndustry}
            style={{ alignSelf: "flex-end" }}
          >
            Go to Industry
          </Button>
        )}
      </div>
      <Row>
        <Col span={12}>
          <Table
            columns={columns}
            dataSource={[
              ...allIndustries,
              ...(sectorsDetails?.industries ? sectorsDetails?.industries : []),
            ]}
            size="small"
            pagination={false}
            rowSelection={{
              type: "radio",
              onChange: (selectedRowKeys, selectedRows) => {
                if (
                  selectedRows.length > 0 &&
                  selectedRows[0].name !== "All Industries"
                ) {
                  setSelectedIndustry(selectedRows[0]);
                  handleUpdateState(selectedRows[0]);
                  return;
                }
                setSelectedIndustry(null);
                handleSelectAllIndustry();
              },
            }}
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "5px",
              maxHeight: "500px",
              overflowY: "auto",
            }}
            sticky
          />
        </Col>
        <Col span={12}>
          <PolarChart
            handleSelectItem={handleSelectItem}
            dynamicDots={industryDetail?.overview_status}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} sm={24}>
          <RiskSummaryChart
            dataSource={industryDetail?.overview_status?.risk_summary}
          />
        </Col>
        <Col md={12} sm={24}>
          <OpportunitySummaryChart
            dataSource={industryDetail?.overview_status?.opportunity_summary}
          />
        </Col>
        <Col md={24} sm={24}>
          <ImpactForecastingGraph
            dataSource={industryDetail?.impact_forecasting_graph}
          />
        </Col>
        <Col md={24} sm={24}>
          <ComparativeMetricsTable
            dataSource={industryDetail?.comparative_metrics_dashboard}
          />
        </Col>
      </Row>
      <span className={classes.selectSector} style={{ marginTop: "30px" }}>
        Largest Companies in This Sector
      </span>
      <Row gutter={[8, 16]}>
        <Col span={24}>
          <Table
            columns={largestCompaniesColumns}
            dataSource={largestCompanies}
            size="small"
            pagination={false}
            sticky
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              border: "1px solid #f0f0f0",
              borderRadius: "5px",
            }}
          />
        </Col>
        <Col span={12}>
          <span className={classes.selectSector}>ETF Opportunities</span>
          <Table
            columns={etfTableColumns}
            dataSource={etfTableData}
            size="small"
            pagination={false}
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              border: "1px solid #f0f0f0",
              borderRadius: "5px",
            }}
          />
        </Col>
        <Col span={12}>
          <span className={classes.selectSector}>
            Mutual Fund Opportunities
          </span>
          <Table
            columns={mutualFundsColumns}
            dataSource={mutualFundsData}
            size="small"
            pagination={false}
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              border: "1px solid #f0f0f0",
              borderRadius: "5px",
            }}
          />
        </Col>
        <Col span={24}>
          <span className={classes.selectSector}>Research Reports</span>
          <Row gutter={[16, 16]}>
            {sectorsDetails?.research_reports.map((report) => {
              const formattedDate = new Date(
                report.reportDate
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              });
              const titleWithoutDate = report.headHtml
                .replace(
                  /\d{1,2}\/\d{1,2}\/\d{4}|\d{1,2}-\d{1,2}-\d{4}|\d{1,2}\s+\w+\s+\d{4}/g,
                  ""
                )
                .trim();
              return (
                <Col key={report.id} span={12}>
                  <Card hoverable className={classes.reportCard}>
                    <h4 className={classes.reportTitle}>
                      {titleWithoutDate} - {formattedDate}
                    </h4>
                    <p className={classes.reportDescription}>
                      {report.reportTitle.length > 100
                        ? `${report.reportTitle.substring(0, 100)}...`
                        : report.reportTitle}
                    </p>
                    <div className={classes.cardFooter}>
                      <div className={classes.tags}>
                        <Tag color="blue">{report.provider}</Tag>
                        <Tag color="green">{report.reportType}</Tag>
                      </div>
                      {report.reportTitle.length > 100 && (
                        <Button
                          type="link"
                          className={classes.readMoreButton}
                          onClick={() => showPopup(report)}
                        >
                          Read More
                        </Button>
                      )}
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
          {isPopupVisible && (
            <Modal
              title="Full Report"
              visible={isPopupVisible}
              onCancel={hidePopup}
              footer={null}
            >
              <p>{currentReport?.reportTitle}</p>
            </Modal>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default SectorDetailPage;
